export default __webpack_public_path__ + "static/media/sad.84c87bad.png";